// settings.service.ts
import { Injectable } from '@angular/core';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { GroupSettingsByUser } from '../models/settingsByGroups.model';
import { UserSettings, UserSettingsMultipleUpdate, UserSettingsPatch } from '../models/setting.model';
import { ApplicationIdentificator } from '../../store/settings.store';


@Injectable({ providedIn: 'root' })
export class SettingsService extends BaseApiService {

  public async getSettings(applicationId: ApplicationIdentificator): Promise<UserSettings> {
    return await lastValueFrom(this.get<UserSettings>(`api/v1/settings?applicationId=${applicationId}`));
  }

  public async saveSettings(settings: UserSettings): Promise<void> {
    await lastValueFrom(
      this.post<void>(`api/v1/settings/`, settings)
    );
  }

  public async saveSettingsByUserId(userId: string, settings: UserSettings): Promise<void> {
    await lastValueFrom(
      this.post<void>(`api/v1/settings/${userId}`, settings)
    );
  }

  public async saveSettingsByUserIds(userIds: string[], settings: UserSettingsPatch): Promise<void> {
    const payload: UserSettingsMultipleUpdate = { userIds, settings };

    await lastValueFrom(
      this.post<void>(`api/v1/settings/by-userids`, payload)
    );
  }

  public async getSettingsByGroups(applicationId: ApplicationIdentificator): Promise<GroupSettingsByUser[]> {
    return await firstValueFrom(this.get<GroupSettingsByUser[]>(`api/v1/settings/by-group?applicationId=${applicationId}`));
  }
}